// Mock data for customers
import { v4 as uuidv4 } from 'uuid';

// Helper function to create random dates within a range
function randomDate(start, end) {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}

// Create an array of 50 mock customers
const generateCustomers = (count = 50) => {
  const loyaltyTiers = ['STANDARD', 'SILVER', 'GOLD', 'VIP'];
  const firstNames = ['John', 'Emma', 'Michael', 'Sophia', 'James', 'Olivia', 'William', 'Ava', 'Alexander', 'Isabella', 'Raj', 'Priya', 'Chen', 'Yuki', 'Mohammed', 'Fatima', 'Carlos', 'Maria'];
  const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Miller', 'Davis', 'Garcia', 'Rodriguez', 'Wilson', 'Martinez', 'Anderson', 'Taylor', 'Thomas', 'Hernandez', 'Moore', 'Martin', 'Jackson', 'Thompson', 'White', 'Lopez', 'Lee', 'Gonzalez', 'Harris', 'Clark', 'Lewis', 'Robinson', 'Walker', 'Perez', 'Hall'];
  const domains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'icloud.com'];
  
  const customers = [];
  
  for (let i = 0; i < count; i++) {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const domain = domains[Math.floor(Math.random() * domains.length)];
    const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}${Math.floor(Math.random() * 1000)}@${domain}`;
    
    const loyaltyTier = loyaltyTiers[Math.floor(Math.random() * loyaltyTiers.length)];
    const totalOrders = Math.floor(Math.random() * 50) + 1;
    
    // Higher tier customers have higher lifetime value
    let lifetimeValue;
    switch(loyaltyTier) {
      case 'VIP':
        lifetimeValue = Math.random() * 5000 + 5000;
        break;
      case 'GOLD':
        lifetimeValue = Math.random() * 2000 + 2000;
        break;
      case 'SILVER':
        lifetimeValue = Math.random() * 1000 + 800;
        break;
      default:
        lifetimeValue = Math.random() * 500 + 100;
    }
    
    // Create some re-commerce activity
    const totalReturns = Math.floor(Math.random() * 10);
    const totalRepairs = Math.floor(Math.random() * 5);
    const totalResales = Math.floor(Math.random() * 3);
    
    // Generate a random date within the last year for the last order
    const lastOrderDate = randomDate(new Date(Date.now() - 365 * 24 * 60 * 60 * 1000), new Date());
    
    customers.push({
      id: uuidv4(),
      firstName,
      lastName,
      email,
      loyaltyTier,
      totalOrders,
      lifetimeValue,
      lastOrderDate: lastOrderDate.toISOString(),
      reCommerceActivity: {
        totalReturns,
        totalRepairs,
        totalResales
      }
    });
  }
  
  return customers;
};

export const customersMockData = {
  items: generateCustomers(50),
  totalCount: 50,
  pageInfo: {
    hasNextPage: false,
    hasPreviousPage: false
  }
};